// extracted by mini-css-extract-plugin
export var accordionContent = "home-module--accordion-content--Obh9d accordion-module--accordion-content--0lJF0";
export var heading = "home-module--heading--HAdsg typography-module--heading--AdW8T colors-module--color-body--wh0CY";
export var inline = "home-module--inline--8hbI3";
export var link = "home-module--link--u1RL4";
export var paragraph = "home-module--paragraph--E3FX6 typography-module--paragraph---kHwl typography-module--link--89r-u typography-module--body--LdsA5 colors-module--color-body--wh0CY";
export var section = "home-module--section--kTUEU layout-module--section--80yNc";